import withLayout from 'apps/web-client/src/hoc/with-layout';

import { WopiEditorController } from './wopi-editor.controller';

const WopiEditor: React.FC = () => {
  return <WopiEditorController />;
};
export default withLayout(WopiEditor);
